import styled from 'styled-components';
import Drawer from '../../../../components/Drawer';
import Button from '../../../../components/Button';
import { TbArrowNarrowRight } from 'react-icons/tb';
import { Flex } from '@mantine/core';

import Table from '../../../../components/Table';

import dayjs from '../../../../utils/dayjs';
import { useMemo, useState } from 'react';
import Checkbox from '../../../../components/Checkbox';

export function ShareAIFM({ isOpen, onClose, workflows, groupId, refetch, groupName }) {
  const [selectedWorkflows, setSelectedWorkflows] = useState([]);

  const onSelectWorkflow = id => {
    if (selectedWorkflows.includes(id)) {
      setSelectedWorkflows(prev => prev.filter(value => value !== id));
    } else {
      setSelectedWorkflows(prev => [...prev, id]);
    }
  };

  const onCancel = () => {
    onClose();
    setSelectedWorkflows([]);
  };

  const onUpdate = () => {};

  const _columns = useMemo(
    () => [
      {
        title: 'Name',
        key: 'name',
        render: data => {
          return (
            <Flex alignItems="center" gap={6}>
              <Checkbox
                onChange={() => onSelectWorkflow(data.id)}
                checked={selectedWorkflows.includes(data.id)}
              />
              <span>{data.name}</span>
            </Flex>
          );
        }
      },
      {
        title: 'Created date',
        key: 'created_at',
        render: data => {
          return dayjs(data.created_at).format('DD-MM-YYYY HH:mm');
        }
      },
      {
        title: 'Updated Date',
        key: 'modified_at',
        render: data => {
          return dayjs(data.modified_at).format('DD-MM-YYYY HH:mm');
        }
      },
      {
        title: 'Assigned To',
        render: data => data.assigned_user_name || '-'
      }
    ],
    [selectedWorkflows]
  );

  return (
    <Drawer
      style={{
        width: '675px'
      }}
      title="Share Consolidated AIFM With"
      withContainer={false}
      open={isOpen}
      onClose={onClose}
    >
      <BodyStyle>
        <div className="table">
          {workflows?.length > 0 && (
            <Table
              trClassName="project-table-tr"
              hasIndex={false}
              columns={_columns}
              data={workflows}
              className="table"
            />
          )}
        </div>
        <div className="buttons">
          <Button onClick={onCancel} variant="outlined-gray" size="sm">
            Cancel
          </Button>
          <Button
            disabled={selectedWorkflows.length === 0}
            size="sm"
            rightIcon={<TbArrowNarrowRight fontSize="14px" />}
            onClick={onUpdate}
          >
            Continue {selectedWorkflows.length > 0 ? `(${selectedWorkflows.length})` : ''}
          </Button>
        </div>
      </BodyStyle>
    </Drawer>
  );
}

const BodyStyle = styled.div`
  margin-top: 16px;
  .table {
    max-height: 80vh;
    overflow: auto;
    .disabled-column {
      background-color: #f9fafb;
      color: #adb5bd;
    }
  }
  .buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 56px;
  }
`;
